import { createBrowserRouter, Navigate, useLocation } from "react-router-dom";
import PrivateRoute from "./privateRoute";
import NotFound from "../../components/notFound/notFound";
import {
  attribute,
  authPassword,
  authProfile,
  blogDetail,
  blogList,
  buyNow,
  home,
  variantList,
  orders,
  ordersDetails,
  orderSummary,
  paymentFailed,
  paymentProcessing,
  paymentSuccess,
  paymentSummary,
  profile,
  renewal,
  renewalDetails,
  signIn,
  signUp,
  compare,
  kyc,
  kycReturn,
} from "./constant";
import SignIn from "../../auth/signIn";
import SignUp from "../../auth/signUp";
import Profile from "../../auth/profile";
import Password from "../../auth/setPassword";
import Home from "../../pages/home";
import ProductVariant from "../../pages/productVariant";
import ProfilePage from "../../pages/profile";
import BuyNow from "../../pages/proposalForm";
import Orders from "../../pages/orders";
import BlogRenderer from "../../pages/home/components/blog/blogDetails";
import PaymentSuccess from "../../components/paymentStatus/sucess";
import PaymentFailed from "../../components/paymentStatus/failure";
import SelectedOrder from "../../pages/orders/selectedOrder";
import OrderSummary from "../../pages/orderSummary";
import { useSelector } from "react-redux";
import PaymentSummary from "../../pages/paymentSummary";
import BlogList from "../../pages/home/components/blog/blogList";
import Renewal from "../../pages/renewal/components/detail";
import RenewalList from "../../pages/renewal";
import Attribute from "../../pages/attribute";
import Compare from "../../pages/compare";
import PaymentProcessing from "../../pages/paymentProcessing";
import KycPage from "../../pages/kyc";
import KycReturnPage from "../../pages/kyc/kycReturn";

const ProtectedRoute = () => {
  const customerData = useSelector((state) => state.common.customerData);
  const agDetails = useSelector((state) => state.common.agDetails);
  const location = useLocation();
  // profile_enabled false (MSCDA): profile is filled after the order, so allow first login here
  if (customerData.is_first_login === 1 && agDetails?.profile_enabled !== false) {
    return <Navigate to="/" replace />;
  }
  const routeMapping = {
    // [buyNow]: <BuyNow />,
    // [paymentSummary]: <paymentSummary />,
    // [summary]: <Summary />,
    [orders]: <Orders />,
    [ordersDetails]: <SelectedOrder />,
    [renewal]: <RenewalList />,
    // [paymentSuccess]: <PaymentSuccess />,
    // [paymentFailed]: <PaymentFailed />,
    [variantList]: <ProductVariant />,
  };

  return routeMapping[location.pathname] || null;
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <PrivateRoute />,
    // hasErrorBoundary: true,
    // errorElement: <Home />,
    children: [
      {
        index: true,
        element: <Navigate to={home} replace />,
      },
      {
        path: home,
        element: <Home />,
      },
      {
        path: variantList,
        element: <ProtectedRoute />,
      },
      {
        path: profile,
        element: <ProfilePage />,
      },
      {
        path: buyNow,
        element: <BuyNow />,
      },
      {
        path: paymentSummary,
        element: <PaymentSummary />,
      },
      {
        path: orders,
        element: <ProtectedRoute />,
      },
      {
        path: ordersDetails,
        element: <ProtectedRoute />,
      },
      {
        path: renewal,
        element: <ProtectedRoute />,
      },
      {
        path: renewalDetails,
        element: <Renewal />,
      },
      // {
      //   path: portfolio,
      //   element: <Portfolio />,
      // },
      {
        path: paymentSuccess,
        element: <PaymentSuccess />,
      },
      {
        path: paymentFailed,
        element: <PaymentFailed />,
      },
      {
        path: `${blogDetail}/:slug`,
        element: <BlogRenderer />,
      },
      {
        path: orderSummary,
        element: <OrderSummary />,
      },
      {
        path: `${blogList}/:id`,
        element: <BlogList />,
      },
      {
        path: attribute,
        element: <Attribute />,
      },
      {
        path: compare,
        element: <Compare />,
      },
      {
        path: kyc,
        element: <KycPage />,
      },
      {
        path: kycReturn,
        element: <KycReturnPage />,
      },
    ],
  },
  {
    // Public: Cashfree deep-links the browser straight here after checkout, so
    // this must render even when the auth token was lost during the redirect.
    path: paymentProcessing,
    element: <PaymentProcessing />,
  },
  {
    path: signIn,
    element: <SignIn />,
  },
  {
    path: signUp,
    element: <SignUp />,
  },
  {
    path: authProfile,
    element: <Profile />,
  },
  {
    path: authPassword,
    element: <Password />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

export default router;
